import HomeHeroBGSrc from "../assets/img/home/Welcome-to-Member-Online-Header-Banner_2560x600.jpg";
import HomeHeroBGSrcMobile from "../assets/img/home/Welcome-to-Member-Online-Header-Banner_640x300.jpg";
import HomeHeroBGHolSrc from "../assets/img/hol/home-hero-1000.jpg";
import AccessHealthSupportSrc from "../assets/img/card-images/heart-blue.svg";
import ExploreMyCoverSrc from "../assets/img/card-images/explore-my-cover.svg";
import MyClaimsSrc from "../assets/img/card-images/my-claims.svg";
import AccessHealthSupportHolSrc from "../assets/img/hol/card-images/heart-orange.svg";
import ExploreMyCoverHolSrc from "../assets/img/hol/card-images/explore-my-cover.svg";
import MyClaimsHolSrc from "../assets/img/hol/card-images/go-to-my-claims.svg";
import HealthStoreBannerSrc from "../assets/img/card-images/Access-Health-Support_1112-x-646.jpg";
import HealthStorePromoSrcMobile from "../assets/img/card-images/Access-Health-Support_580x340.jpg";
import HealthStoreBannerHolSrc from "../assets/img/hol/customer-offers.jpg";
import C4CBannerSrc from "../assets/img/card-images/c4c_1112x646.jpg";
import C4CBannerMolSrc from "../assets/img/cancer/GettyImages-1171155491-small.jpg";
import C4CPromoSrcMobile from "../assets/img/card-images/c4c_580x340.jpg";
import C4CPromoMolSrcMobile from "../assets/img/cancer/GettyImages-1171155491-small.jpg";
import MedExpertBannerSrc from "../assets/img/card-images/Ask-A-Medical-Expert_1112x646.jpg";
import MedExpertPromoSrcMobile from "../assets/img/card-images/Ask-A-Medical-Expert_580x340.jpg";
import MedExpertBannerHolSrc from "../assets/img/hol/doctor.jpg";
import ThumbnailList1Src from "../assets/img/card-images/access-health-information_224x224.jpg";
import ThumbnailList1HolSrc from "../assets/img/hol/health-info.jpg";
import ThumbnailList2Src from "../assets/img/card-images/DCA_224x224.jpg";
import ThumbnailList3Src from "../assets/img/card-images/FastTrack_Appointments_224x224.jpg";
import ThumbnailList4Src from "../assets/img/card-images/Find Treatment_Int 224x224.jpg";
import { Paths, Urls } from "../constants/UrlConstants";
import { ButtonConfig, InboxPages } from "../constants/Constants";
import Treatment from "../assets/img/card-images/Treatment.png";
import TreatmentHol from "../assets/img/card-images/TreatmentHol.png";
import File from "../assets/img/card-images/File.png";
import FileHOL from "../assets/img/card-images/FileHol.png";
import Activitytracker from "../assets/img/card-images/Activitytracker.png";
import ActivitytrackerHOL from "../assets/img/card-images/ActivitytrackerHol.png";
import OnlineGP from "../assets/img/card-images/OnlineGP.png";
import OnlineGPHol from "../assets/img/card-images/OnlineGPHol.png";
import Cashback from "../assets/img/card-images/Cashback.png";
import CashbackHol from "../assets/img/card-images/CashbackHol.png";
import Messages from "../assets/img/card-images/Messages.png";
import MessagesHol from "../assets/img/card-images/MessagesHol.png";
import CarouselPhysio from "../assets/img/carousel/carouselPhysio.png";
import Appointment from "../assets/img/carousel/GPImage.png";
import CancerImg from "../assets/img/carousel/CancerImage.png";
import HealthImg from "../assets/img/carousel/247health.png";
import Assessment from "../assets/img/carousel/assessment.png";
import Dental from "../assets/img/carousel/dental.png";
import Referral from "../assets/img/carousel/referral.png";
import Gym from "../assets/img/carousel/gym.png";
import Specialist from "../assets/img/carousel/specialist.png";
import CancerDiagnostic from "../assets/img/carousel/cancerDiagnostic.png";
import Reward from "../assets/img/carousel/reward.png";
import React from "react";

const thumbNailHealthInformation = {
  IconSrc: {
    Any: ThumbnailList1Src,
    HOL: ThumbnailList1HolSrc
  },
  Heading: "Health information",
  Description:
    "Find information online and local services with HealthUnlocked, helping you to manage and understand your health.",
  LinkText: "Discover",
  LinkTo: Paths.HealthInformation
};
const thumbNailGPAppointments = {
  IconSrc: {
    Any: ThumbnailList2Src
  },
  Heading: "GP appointments 24/7",
  Description:
    "Speak to a doctor when you want to, wherever you are, through your smartphone or laptop using our AXA Doctor at Hand service.",
  LinkText: "Discover",
  LinkTo: Paths.GPAppointments247
};
const thumbNailFastTrackAppointments = {
  IconSrc: ThumbnailList3Src,
  Heading: "Specialist Appointment Booking Service",
  Description:
    "When you need to see a specialist quickly, our Specialist Appointment Booking Service team will make it happen.",
  LinkText: "Discover",
  LinkTo: Paths.FastTrack
};
const thumbNailFindTreatment = {
  IconSrc: ThumbnailList4Src,
  Heading: "Find treatment",
  Description:
    "MyGlobe can help you find the right medical provider, wherever you need them, with access to our global network.",
  LinkText: "Discover",
  ExternalLinkTo: Urls.FindTreatmentInternational
};

const Home = {
  MainContent: {
    HOL: "Welcome to Customer Online.",
    MOL: "Welcome to Member Online."
  },
  Common: {
    MakeAClaim: "Make a Claim",
    MakeAClaimLink: Paths.MakeAClaim,
    View: "View",
    At: "at",
    No: "no"
  },
  UploadDocumentsUrl: {
    Any: Paths.MessageCentre + "?page=" + InboxPages.GeneralQuery,
    International: Paths.MessageCentre + "?page=" + InboxPages.SubmitInvoice
  },
  Hero: {
    HomeHeroBGSrc: {
      Any: HomeHeroBGSrc,
      HOL: HomeHeroBGHolSrc
    },
    HomeHeroBGSrcMobile: {
      Any: HomeHeroBGSrcMobile,
      HOL: HomeHeroBGHolSrc
    },
    HeadingWelcome: {
      International: "",
      // Any: "Welcome to"
      Any: "Welcome"
    },
    HeadingApp: {
      International: "",
      // HOL: "Customer Online",
      // Any: "Member Online"
      HOL: ", how can we help you",
      Any: ", how can we help you"
    },
    LastLoggedIn: "Last logged in:",
    LatestUpdates: "Latest updates",
    YourActivity: "Your activity",
    YouHave: "You have",
    YouHaveReceived: "You have received",
    NewNotifications: "new notifications",
    Notifications: "notifications",
    NeedYourAction: "that need your action",
    NewMessages: "new messages",
    // MembershipNumber: "Membership number",
    // RenewalDate: "Renewal date",
    MembershipNumber: "MEMBERSHIP NUMBER",
    RenewalDate: "RENEWAL DATE",
    Renewal: {
      Any: "Your plan is due to",
      HOL: "Your policy is due to"
    },
    RenewalLink: "renew ",
    UploadLink: "Upload documents",
    HelpLinks: "How can we help you?"
  },
  Cards: {
    ExploreMyCoverSrc: {
      IconSrc: {
        Any: ExploreMyCoverSrc,
        HOL: ExploreMyCoverHolSrc
      },
      Heading: "Explore my cover",
      Description: {
        Any:
          "Take a look at your cover details and download your policy documents.",
        HOL:
          "Take a look at your cover details and download your policy documents."
      },
      LinkText: "Cover",
      LinkTo: Paths.Cover,
      ExternalLinkTo: null
    },
    HomeMyCoverSrc: {
      IconSrc: {
        Any: Treatment,
        HOL: TreatmentHol
      },
      Heading: "Need access to treatment?",
      Description: {
        Any:
          "Start a claim.",
        HOL:
          "Start a claim."
      },
      LinkText: "GET STARTED",
      LinkTo: Paths.MakeAClaim,
      ExternalLinkTo: null
    },

    HomepolicySrc: {
      IconSrc: {
        Any: File,
        HOL: FileHOL
      },
      Heading: "Need your policy documents?",
      Description: {
        Any:
          "Explore your plan benefits and check what you’re covered for.",
        HOL:
          "Explore your plan benefits and check what you’re covered for."
      },
      LinkText: "VIEW MY DOCUMENTS",
      LinkTo: Paths.CoverDocuments,
      ExternalLinkTo: null
    },
    HomeEAPpolicySrc: {
      IconSrc: {
        Any: File,
        HOL: FileHOL
      },
      Heading: "Need your membership documents?",
      Description: {
        Any:
          "Explore your plan benefits and check what you're covered for.",
        HOL:
          "Explore your plan benefits and check what you're covered for.",
        Lapse:
          "Explore your plan benefits and check what you were covered for."
      },
      LinkText: "VIEW MY DOCUMENTS",
      LinkTo: Paths.CoverDocuments,
      ExternalLinkTo: null
    },
    HomeClaimSrc: {
      IconSrc: {
        Any: Activitytracker,
        HOL: ActivitytrackerHOL
      },
      Heading: "Need to view your claims?",
      Description: {
        Any:
          "View your claims history and current claim updates.",
        HOL:
          "View your claims history and current claim updates.",
        Lapse:
          "View you claims history.",
      },
      LinkText: "VIEW MY CLAIMS",
      LinkTo: Paths.Claims,
      ExternalLinkTo: null
    },

    HomeGPSrc: {
      IconSrc: {
        Any: OnlineGP,
        HOL: OnlineGPHol
      },
      Heading: "Need to talk to a GP?",
      Description: {
        Any:
          "Online GP appointments at a time that suits you.",
        HOL:
          "Online GP appointments at a time that suits you."
      },
      LinkText: "BOOK APPOINTMENT",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null
    },

    HomeclaimMoneySrc: {
      IconSrc: {
        Any: Cashback,
        HOL: CashbackHol
      },
      Heading: "How to claim money back",
      Description: {
        Any:
          "Claim money back if you’ve paid a medical provider.",
        HOL:
        "Claim money back if you’ve paid a medical provider.",
      },
      LinkText: "CLAIM A PAYMENT",
      LinkTo: Paths.MakeAClaim,
      ExternalLinkTo: null
    },

    HomeTouchSrc: {
      IconSrc: {
        Any: Messages,
        HOL: MessagesHol
      },
      Heading: "Want to upload a document or get in touch?",
      Description: {
        Any:
          "Upload a GP referral letter or other document, or get in touch.",
        HOL:
          "Upload a GP referral letter or other document, or get in touch.",
      },
      LinkText: "Get in touch",
      LinkTo: null,
      ExternalLinkTo: true
    },

    MyClaimsSrc: {
      IconSrc: {
        Any: MyClaimsSrc,
        HOL: MyClaimsHolSrc
      },
      Heading: "Go to my claims",
      Description:
        "View the details of the claims that you've made and take any actions needed.",
      LinkText: "Claims",
      LinkTo: Paths.Claims,
      ExternalLinkTo: null
    },
    AccessHealthSupportSrc: {
      IconSrc: {
        Any: AccessHealthSupportSrc,
        HOL: AccessHealthSupportHolSrc
      },
      Heading: "Access health support",
      Description: {
        International:
          "We offer you an independent second opinion at no extra cost.",
        Any:
          "Discover how we can support you and your family's health, every step of the way."
      },
      LinkTo: {
        International: null,
        Any: Paths.HealthSupport,
        HOL: Paths.HealthHub
      },
      ExternalLinkTo: {
        International: Urls.HealthSupportInternational,
        Any: null
      }
    },
   
    HealthStore: {
      IconSrc: {
        Any: HealthStoreBannerSrc,
        HOL: HealthStoreBannerHolSrc
      },
      IconSrcMobile: {
        Any: HealthStorePromoSrcMobile,
        HOL: HealthStoreBannerHolSrc
      },
      Heading: {
        HOL: "View your customer offers",
        Any: "View your member offers"
      },
      Description: {
        Any:{
          Any:["Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment."],
          LargeCorporate:["Keep fit for less with our special gym offer."]
        },
          
        HOL:
          "Keep fit for less with our special gym offer or explore your health and lifestyle with a discounted health assessment."
      },
      LinkText: {
        HOL: "Customer offers",
        Any: "Member offers"
      },
      LinkTo: Paths.HealthStore,
      ExternalLinkTo: null
    },
    Check4Cancer: {
      IconSrc: {
        HOL: C4CBannerSrc,
        Any: C4CBannerMolSrc,
        Saga: C4CBannerSrc
      },
      IconSrcMobile: {
       HOL: C4CPromoSrcMobile,
       Any: C4CPromoMolSrcMobile,
       Saga: C4CPromoSrcMobile
      },
      Heading:{
        HOL: "Prostate cancer diagnostic service",
        Any: "Cancer diagnostic services",
        Saga : "Prostate cancer diagnostic service"
      },
      Description:{
        HOL:  "We’ve teamed up with Check4Cancer to develop a new prostate cancer diagnostic service.",
        Any: "Providing speedy access to specialist diagnostic tests for skin, breast and prostate concerns.",
        Saga:  "We’ve teamed up with Check4Cancer to develop a new prostate cancer diagnostic service.",
      },
      LinkText:{
        HOL: "Find out more",
        Any: "Cancer diagnostic services",
        Saga: "Find out more"
      },
      LinkTo: {
        HOL: Paths.Check4Cancer,
        Any: Paths.Check4Cancer,
        Saga: Paths.Check4Cancer
      },
      ExternalLinkTo: null,
      AriaLabel: {
        HOL: "Find out more about the prostate cancer diagnostic service",
        Any: "Find out more about the cancer diagnostic service",
        Saga: "Find out more about the prostate cancer diagnostic service",
      },
    },
    AskMedExpert: {
      IconSrc: {
        Any: MedExpertBannerSrc,
        HOL: MedExpertBannerHolSrc
      },
      IconSrcMobile: {
        Any: MedExpertPromoSrcMobile,
        HOL: MedExpertBannerHolSrc
      },
      Heading: {
        Any: "24/7 health support line",
        HOL: "24/7 health support line"
      },
      Description:
        "Speak to one of our expert nurses, counsellors, midwives and pharmacists about your health, anytime, either online or on the phone.",
      LinkText: {
        Any: "24/7 health support line",
        HOL: "24/7 health support line"
      },
      LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null
    }
  },
  IndividualCarousel: {
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment},
      Heading:
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    CancerSection:{
      IconSrc: {
        Any: CancerImg,
      },
      Heading: 
      "Worried about cancer symptoms?",
      Description:
      <React.Fragment>Through your AXA Health membership you may have access to expert support for breast and skin concerns - available to members <b>aged 18 and over. And for prostate concerns - available to members aged 40 and over with raised PSA levels.</b></React.Fragment>,
      LinkText: 
       "More about cancer Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_c4c
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",  
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
      LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    DentalSupport:{
      IconSrc: {
        Any: Dental,
      },
      Heading: 
      "Dental cover you can smile about",
      Description:
        "Our dental cover is designed to help you maintain a healthy smile, and help ease the financial concerns of dental treatment.",
      LinkText: 
       "More about dental cover",
      LinkTo: null,
      ExternalLinkTo: Urls.DentalInsurance,
      id:ButtonConfig.carcta_mol_hp_mm_denc,
    },
    ReferFriend:{
      IconSrc: {
        Any: Referral,
      },
      Heading: 
      "Refer a friend",
      Description:
        "Tell your friends! If they join us after you've referred them, we'll send you a reward and give one to your friends too. Terms apply.",
      LinkText: 
       "Refer a friend",
      LinkTo: Paths.HealthStore+'?divRef=referAFriendOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_raf,
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },
    SpecialistAppointment:{
      IconSrc: {
        Any: Specialist,
      },
      Heading: 
      "Specialist appointment booking service",
      Description:
        "If your GP says you need to see a specialist, tell them you have AXA Health cover. Ask them for an 'open referral' and we can book your specialist appointment for you.",
      LinkText: 
       "more about our booking service",
      LinkTo: Paths.FastTrack,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_bk
    },    
  },
  IndividualMOBCarousel: {
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment},
      Heading:
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    CancerSection:{
      IconSrc: {
        Any: CancerImg,
      },
      Heading: 
      "Worried about cancer symptoms?",
      Description:
        <React.Fragment> Get the help you need. We’ve made sure our members can access expert support for breast, skin and prostate concerns. Available for members <b>aged 18 and over and depending on your cover.</b></React.Fragment>,
      LinkText: 
       "More about cancer Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_c4c
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",  
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
      LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    DentalSupport:{
      IconSrc: {
        Any: Dental,
      },
      Heading: 
      "Dental cover you can smile about",
      Description:
        "Our dental cover is designed to help you maintain a healthy smile, and help ease the financial concerns of dental treatment.",
      LinkText: 
       "More about dental cover",
      LinkTo: null,
      ExternalLinkTo: Urls.DentalInsurance,
      id:ButtonConfig.carcta_mol_hp_mm_denc,
    },
    ReferFriend:{
      IconSrc: {
        Any: Referral,
      },
      Heading: 
      "Refer a friend",
      Description:
        "Tell your friends! If they join us after you've referred them, we'll send you a reward and give one to your friends too. Terms apply.",
      LinkText: 
       "Refer a friend",
      LinkTo: Paths.HealthStore+'?divRef=referAFriendOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_raf,
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },
    SpecialistAppointment:{
      IconSrc: {
        Any: Specialist,
      },
      Heading: 
      "Specialist appointment booking service",
      Description:
        "If your GP says you need to see a specialist, tell them you have AXA Health cover. Ask them for an 'open referral' and we can book your specialist appointment for you.",
      LinkText: 
       "more about our booking service",
      LinkTo: Paths.FastTrack,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_bk
    },    
  },
  HOlIndividualCarousel:{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment,
      },
      Heading: 
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    cancerdiagnostic: {
      IconSrc: {
        Any: CancerDiagnostic,
      },
      Heading:
        "Prostate cancer diagnostic service",
      Description:
        <React.Fragment>Through your AXA Health membership you may have access to expert support for prostate concerns. <b>Available to members aged 40 and over with raised PSA levels.</b></React.Fragment>,
        // <React.Fragment>Get the help you need. We’ve made sure our members can access expert support for prostate concerns. Available for members <b>aged 18 and over with confirmation of a raised PSA reading.</b></React.Fragment>,
      LinkText:
        "More about Prostate Checks",
      //LinkTo: Paths.Check4Cancer,
      LinkTo: Paths.Check4CancerProstate,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_c4cp,
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
       LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    ReferFriend:{
      IconSrc: {
        Any: Referral,
      },
      Heading: 
      "Refer a friend",
      Description:
        "Tell your friends! If they join us after you've referred them, we'll send you a reward and give one to your friends too. Terms apply.",
      LinkText: 
       "Refer a friend",
      LinkTo: Paths.HealthStore+'?divRef=holNuffieldAndReferAFriendOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_raf,
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },    
  },
  HOlIndividualMOBCarousel: {
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment,
      },
      Heading: 
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    cancerdiagnostic: {
      IconSrc: {
        Any: CancerDiagnostic,
      },
      Heading:
        "Prostate cancer diagnostic service",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure our members can access expert support for prostate concerns. Available for members <b>aged 18 and over with confirmation of a raised PSA reading.</b></React.Fragment>,
      LinkText:
        "More about Prostate Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_c4cp,
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
       LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    AmazonReward:{
      IconSrc: {
        Any:  Reward,
      },
      Heading: 
      "Refer a business",
      Description:
        "Both you and your business contact could get a reward when you refer them to us, and they take out a small business healthcare plan. Terms apply.",
      LinkText: 
       "Refer a business",
      LinkTo: Paths.HealthStore+'?divRef=molSmeCustomerReferral',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_rab,
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },    
  },
  SMECarousel :{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment,
      },
      Heading: 
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    CancerSection:{
      IconSrc: {
        Any: CancerImg,
      },
      Heading: 
      "Worried about cancer symptoms?",
      Description:
      <React.Fragment>Through your AXA Health membership you may have access to expert support for breast and skin concerns - available to members <b>aged 18 and over. And for prostate concerns - available to members aged 40 and over with raised PSA levels.</b></React.Fragment>,
      LinkText: 
       "More about cancer Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_c4c
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
       LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    AmazonReward:{
      IconSrc: {
        Any:  Reward,
      },
      Heading: 
      "Refer a business",
      Description:
      <React.Fragment>Both you and your business contact could get <b>a £100 Amazon gift card </b> reward when you refer them to us, and they take out a small business healthcare plan. Terms apply.</React.Fragment>,
      LinkText: 
       "Refer a business",
      LinkTo: Paths.HealthStore+'?divRef=molSmeCustomerReferral',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_rab,
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },
    SpecialistAppointment:{
      IconSrc: {
        Any: Specialist,
      },
      Heading: 
      "Specialist appointment booking service",
      Description:
        "If your GP says you need to see a specialist, tell them you have AXA Health cover. Ask them for an 'open referral' and we can book your specialist appointment for you.",
      LinkText: 
       "more about our booking service",
      LinkTo: Paths.FastTrack,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_bk
    },    
  },
  LargeCorporateCarousel:{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment,
      },
      Heading: 
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    CancerSection:{
      IconSrc: {
        Any: CancerImg,
      },
      Heading: 
      "Worried about cancer symptoms?",
      Description:
      <React.Fragment>Through your AXA Health scheme you may have access to expert support for breast and skin concerns - available to members <b>aged 18 and over. And for prostate concerns - available to members aged 40 and over with raised PSA levels.</b></React.Fragment>,
      LinkText: 
       "More about cancer Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_c4c
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
       LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },
    SpecialistAppointment:{
      IconSrc: {
        Any: Specialist,
      },
      Heading: 
      "Specialist appointment booking service",
      Description:
        "If your GP says you need to see a specialist, tell them you have AXA Health cover. Ask them for an 'open referral' and we can book your specialist appointment for you.",
      LinkText: 
       "more about our booking service",
      LinkTo: Paths.FastTrack,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_bk
    },
  },
  SagaCarousel:{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    cancerdiagnostic: {
      IconSrc: {
        Any: CancerDiagnostic,
      },
      Heading:
        "Prostate cancer diagnostic service",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure our members can access expert support for prostate concerns. Available for members <b>aged 18 and over with confirmation of a raised PSA reading.</b></React.Fragment>,
      LinkText:
        "More about Prostate Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
       LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    SpecialistAppointment:{
      IconSrc: {
        Any: Specialist,
      },
      Heading: 
      "Specialist appointment booking service",
      Description:
        "If your GP says you need to see a specialist, tell them you have AXA Health cover. Ask them for an 'open referral' and we can book your specialist appointment for you.",
      LinkText: 
       "more about our booking service",
      LinkTo: Paths.FastTrack,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_bk
    },
  },
  SagaMOBCarousel:{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    cancerdiagnostic: {
      IconSrc: {
        Any: CancerDiagnostic,
      },
      Heading:
        "Prostate cancer diagnostic service",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure our members can access expert support for prostate concerns. Available for members <b>aged 18 and over with confirmation of a raised PSA reading.</b></React.Fragment>,
      LinkText:
        "More about Prostate Checks",
      LinkTo: Paths.Check4Cancer,
      ExternalLinkTo: null
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
       LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    SpecialistAppointment:{
      IconSrc: {
        Any: Specialist,
      },
      Heading: 
      "Specialist appointment booking service",
      Description:
        "If your GP says you need to see a specialist, tell them you have AXA Health cover. Ask them for an 'open referral' and we can book your specialist appointment for you.",
      LinkText: 
       "more about our booking service",
      LinkTo: Paths.FastTrack,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_bk
    },
  },
  EAPCarousel:{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
        <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment,
      },
      Heading: 
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
      LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    AmazonReward:{
      IconSrc: {
        Any:  Reward,
      },
      Heading: 
      "Refer a business",
      Description:
        "Both you and your business contact could get a reward when you refer them to us, and they take out a small business healthcare plan. Terms apply.",
      LinkText: 
       "Refer a business",
      LinkTo: Paths.HealthStore+'?divRef=molSmeCustomerReferral',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_rab,
    },    
  },
  EAPMOBCarousel:{
    musclebonejoint:{
      IconSrc: {
        Any: CarouselPhysio,
      },
      Heading: 
         "Seeking help for a muscle, bone or joint problem?",
      Description:
      <React.Fragment>Get the help you need. We’ve made sure you can speak to an expert online, fast, and without a GP referral. Available for members<b> aged 18 and over.</b></React.Fragment>,
      LinkText: 
        "our Muscles, bones and joints service",
      LinkTo: Paths.WorkingBody,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_msk,
    },
    Appointment:{
      IconSrc: {
        Any: Appointment,
      },
      Heading: 
         "Online GP appointments that fit around you",
      Description:
      <React.Fragment>Video or phone appointments with a GP or Advanced Clinical Practitioner. <b>Members under 18 on the plan can use the service, as long as the lead member is over 18.</b></React.Fragment>,
      LinkText: 
        "More about Our online GP service",
      LinkTo: Paths.GPAppointments247,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_dh,
    },
    HealthSupport:{
      IconSrc: {
        Any: HealthImg,
      },
      Heading: 
      "24/7 health support line",
      Description:
        "Speak to a nurse or counsellor day or night to support you when you need it most. During the day you can also speak to a midwife or pharmacist.",
      LinkText: 
       "More about 24/7 health support line",
      LinkTo: Paths.AskAMedicalExpert,
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_247
    },
    GymAccess:{
      IconSrc: {
        Any: Gym,
      },
      Heading: 
      "Access to gym discounts",
      Description:
        "Give your fitness routine a boost with discounted membership at well-known gym brands.",
      LinkText: 
       "More about gym discounts",
      LinkTo: Paths.HealthStore+'?divRef=puregymPromoSection',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_gym,
    },
    AssessmentSupport:{
      IconSrc: {
        Any: Assessment,
      },
      Heading: 
      "Get yourself checked out",
      Description:
        "For a little extra reassurance get access to selected health assessment discounts. Choose from different levels of check-up and receive personalised recommendations for your next steps.",
      LinkText: 
       "More about health assessments",
      LinkTo: Paths.HealthStore+'?divRef=nuffieldOffer',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_ass,
    },
    AmazonReward:{
      IconSrc: {
        Any:  Reward,
      },
      Heading: 
      "Refer a business",
      Description:
        "Both you and your business contact could get a reward when you refer them to us, and they take out a small business healthcare plan. Terms apply.",
      LinkText: 
       "Refer a business",
      LinkTo: Paths.HealthStore+'?divRef=molSmeCustomerReferral',
      ExternalLinkTo: null,
      id:ButtonConfig.carcta_mol_hp_mm_rab,
    },    
  },
  ThumbnailList: {
    Heading: "Get more from your membership",
    ListItems: {
      International: [thumbNailFindTreatment, thumbNailFastTrackAppointments],
      Saga: [thumbNailHealthInformation],
      HOL: [thumbNailHealthInformation, thumbNailGPAppointments],
      LargeCorporate: [
        thumbNailHealthInformation,
        thumbNailFastTrackAppointments,
        thumbNailGPAppointments
      ],
      Any: {
        Any: [thumbNailHealthInformation, thumbNailGPAppointments],
        FastTrack: [
          thumbNailHealthInformation,
          thumbNailGPAppointments,
          thumbNailFastTrackAppointments
        ]
      }
    }
  },
  ActionButton: {
    Heading: "Need to get in touch?",
    LinkText: "Contact us",
    LinkTo: Paths.ContactUs
  }
};

if (!window?.axa?.features?.healthUnlockedFeature) {
  Home.ThumbnailList.ListItems.Saga.splice(0, 1);
  Home.ThumbnailList.ListItems.HOL.splice(0, 1);
  Home.ThumbnailList.ListItems.LargeCorporate.splice(0, 1);
  Home.ThumbnailList.ListItems.Any.Any.splice(0, 1);
  Home.ThumbnailList.ListItems.Any.FastTrack.splice(0, 1);
}

export default Home;

export const _thumbNailHealthInformation = thumbNailHealthInformation;
export const _thumbNailGPAppointments = thumbNailGPAppointments;
